import React from 'react';
import { IconProps } from '.';

type SoundIconProps = {
  color?: string;
} & IconProps;

export const SoundIcon: React.FC<SoundIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 18"
    >
      <path
        fill={color}
        d="M9.1 17.8c-.2 0-.39-.06-.561-.17L2.76 13.74H1.038C.466 13.74 0 13.25 0 12.65V5.22c0-.6.466-1.09 1.038-1.09h1.599L8.539.17c.323-.21.723-.23 1.056-.04.334.19.543.56.543.96v15.62c0 .4-.21.77-.543.96a.968.968 0 01-.495.13zM1.047 5.13a.088.088 0 00-.086.09v7.43c0 .05.039.09.086.09h1.866c.095 0 .18.03.257.08l5.892 3.97.134-.08V1.09l-.134-.08-6.016 4.04a.462.462 0 01-.257.08H1.047zM12.26 12.72a.484.484 0 01-.475-.5c0-.28.21-.5.476-.5 1.323 0 2.408-1.27 2.408-2.82 0-1.55-1.076-2.82-2.408-2.82a.484.484 0 01-.476-.5c0-.28.21-.5.476-.5 1.846 0 3.36 1.71 3.36 3.82s-1.514 3.82-3.36 3.82z"
      ></path>
      <path
        fill={color}
        d="M14.44 17.19c-.209 0-.409-.15-.456-.37a.5.5 0 01.343-.61c2.732-.74 4.721-3.82 4.721-7.32 0-3.5-1.904-6.5-4.626-7.3-.257-.07-.4-.35-.333-.62a.476.476 0 01.59-.35C17.81 1.54 20 4.94 20 8.88c0 3.95-2.285 7.43-5.435 8.29-.048.02-.086.02-.124.02z"
      ></path>
    </svg>
  );
};
